import { Columns, LegacyCard, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import TagsCheckbox from "../TagsCheckbox/TagsCheckbox.js";
import SelectedTagsField from "../../../../../common/SelectedTagsField/SelectedTagsField.js";

const DownProductsCard = ({ values }) => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack vertical>
            <Field
              name="downProductIsActiveTags"
              component={TagsCheckbox}
              isTooltip
              label="Tag products that were push down by Stockhide"
            />
            <div style={{ paddingLeft: "1.75rem" }}>
              <Field
                name={"downProductSelectedTags"}
                component={SelectedTagsField}
                labelHidden={true}
                disabled={!values.downProductIsActiveTags}
              />
            </div>
          </Stack>
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default DownProductsCard;